module.exports = __webpack_public_path__ + "static/media/top-bar-battles-icon.bb0e5236.png";